"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Builder = void 0;
var _1 = require(".");
var Runtime_1 = require("./Runtime");
var Tensor_1 = __importDefault(require("./Tensor"));
/**
 * A builder object which can be used to initialize the Rune runtime.
 */
var Builder = /** @class */ (function () {
    function Builder() {
        this.modelHandlers = {};
        this.log = function () { };
    }
    /**
     * Set a handler that will be called every time the Rune logs a message.
     */
    Builder.prototype.onDebug = function (handler) {
        this.log = handler;
        return this;
    };
    /**
     * Add support for a new type of model.
     * @param mimetype The "mimetype" that specifies which type of model being
     * handled.
     * @param constructor A constructor which will load the model.
     * @returns
     */
    Builder.prototype.withModelHandler = function (mimetype, constructor) {
        this.modelHandlers[mimetype] = constructor;
        return this;
    };
    Builder.prototype.build = function (rune) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, modelHandlers, log, imports, runtime;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof rune == "string")) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetch(rune)];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 2:
                        rune = _b.sent();
                        _b.label = 3;
                    case 3:
                        _a = this, modelHandlers = _a.modelHandlers, log = _a.log;
                        imports = new ImportsObject(modelHandlers, log);
                        return [4 /*yield*/, Runtime_1.Runtime.load(rune, imports)];
                    case 4:
                        runtime = _b.sent();
                        return [2 /*return*/, function (readInputs) {
                                if (!runtime) {
                                    throw new Error("A previous call to this Rune has failed, leaving it in an invalid state");
                                }
                                imports.setInputs(readInputs);
                                try {
                                    runtime.call();
                                }
                                catch (e) {
                                    // We encountered an error while invoking the Rune, typically by
                                    // throwing an exception from one of our host functions.  JS
                                    // exceptions abort execution without unwinding the
                                    // WebAssembly/Rust stack so we need to assume the runtime is
                                    // FUBAR.
                                    runtime = undefined;
                                    throw e;
                                }
                                var outputs = __spreadArray([], imports.outputs, true);
                                imports.outputs.length = 0;
                                return { outputs: outputs };
                            }];
                }
            });
        });
    };
    return Builder;
}());
exports.Builder = Builder;
var ImportsObject = /** @class */ (function () {
    function ImportsObject(modelHandlers, logger) {
        this.decoder = new TextDecoder("utf8");
        this.outputs = [];
        this.capabilities = [];
        this.modelHandlers = modelHandlers;
        this.logger = logger;
    }
    ImportsObject.prototype.setInputs = function (readInput) {
        var inputs = this.capabilities.map(function (c) { return c.description(); }).map(readInput);
        for (var i = 0; i < this.capabilities.length; i++) {
            this.capabilities[i].value = inputs[i];
        }
    };
    ImportsObject.prototype.createOutput = function (type) {
        var _a = this, decoder = _a.decoder, outputs = _a.outputs;
        switch (type) {
            case _1.Outputs.tensor:
                return tensorOutput(decoder, outputs);
            case _1.Outputs.serial:
                return serialOutput(decoder, outputs);
            default:
                throw new Error("Unsupported output type: ".concat(type));
        }
    };
    ImportsObject.prototype.createCapability = function (type) {
        var pair = Object.entries(_1.Capabilities).find(function (pair) { return pair[1] == type; });
        if (!pair) {
            throw new Error("Unable to handle capability number ".concat(type));
        }
        var capabilityType = pair[0];
        var cap = new LazyCapability(capabilityType);
        this.capabilities.push(cap);
        return cap;
    };
    ImportsObject.prototype.createModel = function (mimetype, model) {
        var handler = this.modelHandlers[mimetype];
        if (!handler) {
            throw new Error("No handler registered for \"".concat(mimetype, "\" models"));
        }
        return handler(model);
    };
    ImportsObject.prototype.log = function (message) {
        this.logger(message);
    };
    return ImportsObject;
}());
function tensorOutput(decoder, outputs) {
    return {
        consume: function (_a) {
            var buffer = _a.buffer, byteLength = _a.byteLength, byteOffset = _a.byteOffset;
            var shapeLength = new Uint32Array(buffer, byteOffset, 1)[0];
            var shapeBytes = new Uint8Array(buffer, byteOffset + 4, shapeLength);
            var shape = _1.Shape.parse(decoder.decode(shapeBytes));
            var type = shape.type, dimensions = shape.dimensions;
            var elements = new Uint8Array(buffer, byteOffset + 4 + shapeLength, byteLength - 4 - shapeLength);
            var tensor = new Tensor_1.default(shape, elements);
            outputs.push({
                channel: -1,
                dimensions: __spreadArray([], dimensions, true),
                type_name: type,
                elements: tensorAsNumberArray(tensor),
            });
        }
    };
}
function tensorAsNumberArray(tensor) {
    var elementType = tensor.elementType;
    switch (elementType) {
        case "f32":
            var floats = tensor.asTypedArray(elementType);
            return Array.from(floats);
        case "u8":
            var u8s = tensor.asTypedArray(elementType);
            return Array.from(u8s);
        case "u16":
            var u16s = tensor.asTypedArray(elementType);
            return Array.from(u16s);
        case "u32":
            var u32s = tensor.asTypedArray(elementType);
            return Array.from(u32s);
        case "i8":
            var i8s = tensor.asTypedArray(elementType);
            return Array.from(i8s);
        case "i16":
            var i16s = tensor.asTypedArray(elementType);
            return Array.from(i16s);
        case "i32":
            var i32s = tensor.asTypedArray(elementType);
            return Array.from(i32s);
        default:
            throw new Error("Unable to convert a ".concat(tensor.shape.toString(), " to a list of numbers"));
    }
}
function serialOutput(decoder, outputs) {
    // We want the end user to receive all outputs as a return value, but
    // Runes are designed using a callback-based API (it's better for
    // performance). This will create an output which will stash all
    // generated values away in a list so they can be returned at the end.
    return {
        consume: function (data) {
            var json = decoder.decode(data);
            var deserialized = JSON.parse(json);
            if (isOutputValue(deserialized)) {
                outputs.push(deserialized);
            }
            else if (Array.isArray(deserialized) && deserialized.every(isOutputValue)) {
                outputs.push.apply(outputs, deserialized);
            }
            else {
                throw new SerialDeserializeError(json, deserialized);
            }
        }
    };
}
function isNumberArray(value) {
    return Array.isArray(value) && value.every(function (v) { return typeof v === "number"; });
}
function isStringArray(value) {
    return Array.isArray(value) && value.every(function (v) { return typeof v === "string"; });
}
function isOutputValue(value) {
    if (!value) {
        return false;
    }
    var channel = value.channel, dimensions = value.dimensions, elements = value.elements, type_name = value.type_name;
    return typeof channel === "number" &&
        isNumberArray(dimensions) &&
        (isNumberArray(elements) || isStringArray(elements)) &&
        typeof type_name === "string";
}
var LazyCapability = /** @class */ (function () {
    function LazyCapability(type) {
        this.args = {};
        this.type = type;
    }
    LazyCapability.prototype.description = function () {
        return {
            type: this.type,
            args: this.args,
        };
    };
    LazyCapability.prototype.generate = function (dest) {
        if (!this.value) {
            throw new Error();
        }
        dest.set(this.value.elements);
    };
    LazyCapability.prototype.setParameter = function (name, value) {
        this.args[name] = value;
    };
    return LazyCapability;
}());
var SerialDeserializeError = /** @class */ (function (_super) {
    __extends(SerialDeserializeError, _super);
    function SerialDeserializeError(json, deserialized) {
        var _this = _super.call(this, "Unable to deserialize the SERIAL output") || this;
        _this.json = json;
        _this.deserialized = deserialized;
        return _this;
    }
    return SerialDeserializeError;
}(Error));
